import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppLayout from 'pages/AppLayout';

declare global {
  interface Window {
    webEndpoint: string | undefined;
    zmClient: any | undefined;
    mediaStream: any | undefined;
    crossOriginIsolated: boolean;
    ltClient: any | undefined;
  }
}

const App: React.FunctionComponent = (props) => (
  <div className="App">
    <BrowserRouter>
      <AppLayout props={props} />
    </BrowserRouter>
  </div>
);

export default App;
